import React from 'react';
import { AccordionContainer } from '../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../common/components/form/form.module';




export const EventTicketsBasicInfoComponent = ({  selectedEventTickets, events, handleInnerFormChange }: any) => (
    <>
        <AccordionContainer
            child={


                <div className=' grid md:grid-cols-3 lg:grid-cols-3 gap-4'>
                    <InputContainer
                        label="Event"
                        labelField="Name"
                        list={events}
                        onValueChange={(event: any, newValue: any) => {
                            handleInnerFormChange(
                                event.target.value,
                                'EventId',
                            )
                        }}
                        optionName='Choose Event'
                        type="select"
                        value={selectedEventTickets?.EventId}
                        valueField="Id"
                    />
                    <InputContainer
                        label="Name"
                        name="Name"
                        onValueChange={(event: any) => {
                            handleInnerFormChange(
                                event.target.value,
                                'Name',
                            )
                        }}
                        type="text"
                        value={selectedEventTickets?.Name}
                    />
                    <InputContainer
                        label="Price"
                        name="Price"
                        onValueChange={(event: any) => {
                            handleInnerFormChange(
                                event.target.value,
                                'Price',
                            )
                        }}
                        type="number"
                        value={selectedEventTickets?.Price}
                    />
                    <InputContainer
                        label="Currency"
                        name="Currency"
                        onValueChange={(event: any) => {
                            handleInnerFormChange(
                                event.target.value,
                                'Currency',
                            )
                        }}
                        type="text"
                        value={selectedEventTickets?.Currency}
                    />
                    <InputContainer
                        label="Quantity Available"
                        name="QuantityAvailable"
                        onValueChange={(event: any) => {
                            handleInnerFormChange(
                                event.target.value,
                                'QuantityAvailable',
                            )
                        }}
                        type="number"
                        value={selectedEventTickets?.QuantityAvailable}
                    />

                    <InputContainer
                        label="Quantity Sold"
                        name="QuantitySold"
                        onValueChange={(event: any) => {
                            handleInnerFormChange(
                                event.target.value,
                                'QuantitySold',
                            )
                        }}
                        type="number"
                        value={selectedEventTickets?.QuantitySold}
                    />

                    <InputContainer
                        label="Type"
                        name="Type"
                        onValueChange={(event: any) => {
                            handleInnerFormChange(
                                event.target.value,
                                'Type',
                            )
                        }}
                        type="text"
                        value={selectedEventTickets?.Type}
                    />

                    <InputContainer
                        label="Sale Start Date"
                        name="SaleStartDate"
                        onValueChange={(event: any) => {
                            handleInnerFormChange(
                                event.target.value,
                                'SaleStartDate',
                            )
                        }}
                        type="date"
                        value={selectedEventTickets?.SaleStartDate}
                    />

                    <InputContainer
                        label="Sale End Date"
                        name="SaleEndDate"
                        onValueChange={(event: any) => {
                            handleInnerFormChange(
                                event.target.value,
                                'SaleEndDate',
                            )
                        }}
                        type="date"
                        value={selectedEventTickets?.SaleEndDate}
                    />

                    <InputContainer
                        label="Description"
                        name="Description"
                        onValueChange={(event: any) => {
                            handleInnerFormChange(
                                event.target.value,
                                'Description',
                            )
                        }}
                        type="text"
                        value={selectedEventTickets?.Description}
                    />

                    <div className='col-span-full'>
                        <InputContainer
                            label="Benefits"
                            name="Benefits"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'Benefits'
                                )
                            }}
                            type="text"
                            value={selectedEventTickets?.Benefits}
                        />
                        <InputContainer
                            label="Terms And Conditions"
                            name="TermsAndConditions"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'TermsAndConditions'
                                )
                            }}
                            type="text"
                            value={selectedEventTickets?.TermsAndConditions}
                        />
                    </div>

                </div>
            }
            expandedPanel="basicInfo"
            headerTitle="Event Tickets Info"
        />
    </>
)
export default EventTicketsBasicInfoComponent;
